import i18n from '../i18n'

export function displayWithCurrency(amount, currency, noDecimals = false) {
  noDecimals = currency?.zeroDecimal || noDecimals

  return new Intl.NumberFormat(i18n.language || 'en', {
    maximumFractionDigits: noDecimals ? 0 : 2,
    minimumFractionDigits: noDecimals ? 0 : 2,
    style: 'currency',
    currency: currency?.code,
  }).format(amount)
}

export function totalsByCurrency(lines) {
  const totals = {}

  lines.forEach(line => {
    const code = line.currency.code

    totals[code] = { amount: (totals[code]?.amount || 0) + line.amount, currency: line.currency }
  })

  return Object.values(totals)
}

export function displayTotals(totals) {
  return totals.map(total => displayWithCurrency(total.amount, total.currency)).join(' + ')
}
